import React, { useEffect, useState } from 'react'
import { Get_Api } from '../ApiUrls';
import { useNavigate } from 'react-router-dom';
import EnquiryModel from './EnquiryModel';



function CommercialProperties({ Name, Location }) {
    const navigate = useNavigate();
    const [CommercialProperties, setCommercialProperties] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);

    const GetAllCommercialProperties = async () => {
        try {
            setIsUploading(true)
            const queryParams = new URLSearchParams();

            if (Location) {
                queryParams.append("Location", Location);
            }
            if (Name) {
                queryParams.append("Name", Name);
            }
            const response = await Get_Api(`api/admin/GetAllPropertiesCategorywise?Category=Commercial&${queryParams.toString()}`)
            setCommercialProperties(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetAllCommercialProperties();
    }, []);
    useEffect(() => {
        GetAllCommercialProperties();
    }, [Name, Location]);
    const Propertydetails = (id) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/PropertyDetails/${id}`)
    }

    const [selectedProperty, setselectedProperty] = useState(null);

    const [isOpenEnquiryModel, setisOpenEnquiryModel] = useState(false);

    const OpenEnquiryModel = (id) => {
        setselectedProperty(id)
        setisOpenEnquiryModel(true)
    }
    const CloseEnquiryModel = () => {
        setselectedProperty(null)
        setisOpenEnquiryModel(false)
    }


    return (
        <div>
            <div className="container">
                <h1 className="title">Commercial Properties</h1>
                <br />
                <br />
                <div className="property-grid">
                    {CommercialProperties?.length === 0 ? (
                        <p className="no-property-message">No Property in this category</p>
                    ) : (
                        CommercialProperties?.map((property, index) => (
                            <>
                                <div className="property-card" key={index}>
                                    <div className="image-wrapper">
                                        <img src={property?.MainImage} alt={property?.Name} className="property-image" />
                                        {!property?.featured && <span className="featured-badge">Featured</span>}
                                        <span onClick={() => { OpenEnquiryModel(property?._id) }} style={{ cursor: 'pointer' }} className="featured-badge2">Price On Request</span>
                                        {/* <div onClick={() => { Propertydetails(property?._id) }} className="overlay">View Details ↗</div> */}
                                    </div>
                                    <h2 className="property-title">{property?.Name}</h2>
                                    {/* <p className="property-price">INR. {property?.Price}</p> */}
                                    <div className="property-info">
                                        <span className="location">📍 {property?.Address}</span>
                                        {/* <span className="size">📏 {property?.PerSquarePrice}</span> */}
                                    </div>
                                    <button className="seeprop" onClick={() => { Propertydetails(property?._id) }}>See Details</button>
                                </div>
                            </>
                        ))
                    )}
                </div>
            </div>
            <EnquiryModel
                isOpen={isOpenEnquiryModel}
                onClose={CloseEnquiryModel}
                selectedProperty={selectedProperty}
            />
        </div>
    )
}

export default CommercialProperties